import RegistryStatusTag, { RegistryStatus } from 'components/RegistryStatusTag/RegistryStatusTag'
import { NexusEntityForTable } from 'containers/NexusTablePage/types'
import React, { ReactNode } from 'react'
import { CalendarIcon } from '../../../../assets/icons/CalendarIcon'
import { EnvironmentIcon } from '../../../../assets/icons/EnvironmentIcon'
import { BankIcon } from '../../../../assets/icons/BankIcon'
import { UserIcon } from '../../../../assets/icons/UserIcon'
import { JurisdictionsCircleIcon } from '../../../../assets/icons/JurisdictionsCircleIcon'
import { MissingRegistryIcon } from '../../../../assets/icons/MissingRegistryIcon'

type RenderFn<T = RegistryStatus & string[]> = (value: T, fullEntity?: NexusEntityForTable) => ReactNode
export const overviewMapping: {
  key: string
  label: string
  tooltipText?: string
  icon?: ReactNode
  render?: RenderFn
}[] = [
  { key: 'founded', label: '', icon: <CalendarIcon size={14} /> },
  { key: 'mainSite', label: '', icon: <EnvironmentIcon size={14} /> },
  { key: 'entityType', label: 'Company Type', icon: <BankIcon size={14} /> },
  {
    key: 'totalEmployees',
    label: 'Employees',
    icon: <UserIcon size={14} />,
    render: (_value, fullEntity) => fullEntity?.totals?.totalEmployees ?? 'N/A',
  },
  { key: 'jurisdictions', label: 'Jurisdictions', icon: <JurisdictionsCircleIcon size={14} /> },
  {
    key: 'registrationStatus',
    label: 'Status',
    render: function (value?: RegistryStatus) {
      return <RegistryStatusTag status={value} />
    } as RenderFn<RegistryStatus>,
  },
  {
    key: 'missingRegistries',
    label: 'Missing Registries',
    render: function (value: string[], fullEntity?: NexusEntityForTable) {
      return value?.length
        ? value.join(', ')
        : fullEntity?.overviewDetails?.registrationStatus === RegistryStatus.UNREGISTERED
          ? 'All'
          : 'None'
    } as RenderFn<string[]>,
    icon: <MissingRegistryIcon size={14} />,
  },
]
